import { render, staticRenderFns } from "./InlineMention.vue?vue&type=template&id=6f154136&scoped=true&"
import script from "./InlineMention.vue?vue&type=script&lang=js&"
export * from "./InlineMention.vue?vue&type=script&lang=js&"
import style0 from "./InlineMention.vue?vue&type=style&index=0&id=6f154136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f154136",
  null
  
)

/* custom blocks */
import block0 from "./InlineMention.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports